import React from "react";
import { Box, Divider, Heading, SimpleGrid } from "@chakra-ui/react";
import { ProfileForm } from "./ProfileForm";
import { AuthenticatedLayout } from "layouts";
import { useState } from "react";
import ProfileCard from "./ProfileCard";
import ProfileInformation from "./ProfileInformation";

const Profile: React.FC = () => {
  const [editing, setEditing] = useState(false);

  return (
    <AuthenticatedLayout>
      <SimpleGrid
        columns={1}
        gap={8}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Heading as="h1" size="lg">
          Profile
        </Heading>
        <Box maxW="630px" m="0 auto">
          <ProfileCard />
          {/* <SimpleGrid mt={8} columns={[1, 3]} gap={4}>
            <NavLink
              to="/eula"
              label="Consent Form"
              bg="gray.700"
              icon={IoNewspaperOutline}
            />
            <NavLink
              to="/profile"
              label="Notification Preferences"
              bg="gray.700"
              icon={VscBellDot}
            />
            <NavLink
              to="/login"
              onClick={logout}
              label="Logout"
              bg="gray.700"
              icon={RiLogoutBoxRLine}
            />
          </SimpleGrid> */}
        </Box>
        <Divider />
        <Box
          borderRadius="xl"
          width="100%"
          p={8}
          bg="gray.800"
          boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
        >
          {editing ? (
            <ProfileForm callback={() => setEditing(false)} />
          ) : (
            <ProfileInformation callback={() => setEditing(true)} />
          )}
        </Box>
      </SimpleGrid>
    </AuthenticatedLayout>
  );
};

export default Profile;
